import { render, staticRenderFns } from "./addScreenDialog.vue?vue&type=template&id=266eaf27&scoped=true&"
import script from "./addScreenDialog.vue?vue&type=script&lang=js&"
export * from "./addScreenDialog.vue?vue&type=script&lang=js&"
import style0 from "./addScreenDialog.vue?vue&type=style&index=0&id=266eaf27&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266eaf27",
  null
  
)

export default component.exports